import React from 'react';
import { useDropzone, Accept, DropzoneOptions } from 'react-dropzone';
import { AVATAR_TYPE_AND_SIZE } from '@/constants/profile-builder';
import setAlertValue from '@/components/alert';

type Props = {
  children: React.ReactNode;
  className?: string;
  accept?: Accept;
  maxSize?: number;
  noDrag?: boolean;
} & Omit<
  DropzoneOptions,
  | 'noDrag'
  | 'multiple'
  | 'maxFiles'
  | 'noKeyboard'
  | 'accept'
  | 'maxSize'
  | 'onError'
  | 'minSize'
>;

const UploadFile = (props: Props) => {
  const {
    children,
    accept = AVATAR_TYPE_AND_SIZE.ACCEPT,
    maxSize = AVATAR_TYPE_AND_SIZE.SIZE,
    className = '',
    noDrag = true,
    ...otherProps
  } = props;

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    multiple: false,
    maxFiles: 1,
    noKeyboard: true,
    noDrag,
    accept,
    maxSize,
    minSize: 1,
    onError: () => setAlertValue({ msg: '上传失败，请检查文件或重试' }),
    ...otherProps,
  });

  return (
    <div
      className={`${className}${isDragActive ? ' !border-web-blue-500' : ''}`}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      {children}
    </div>
  );
};

export default UploadFile;
